import { createFileRoute } from '@tanstack/react-router';

import { CodebaseTabFlagGate } from '@/components/CodebaseView/CodebaseTabFlagGate';
import { FEATURE_FLAGS } from '@/constants/featureFlags';

// The Atlas tab is gated behind the org-level ATLAS_UI flag (default-off → hidden).
// With the flag off, every page under it lands on the Settings tab.
export const Route = createFileRoute('/$organizationName/cb/$codebaseId/atlas')({
  component: GatedCodebaseAtlasLayout,
});

function GatedCodebaseAtlasLayout() {
  return <CodebaseTabFlagGate flag={FEATURE_FLAGS.ATLAS_UI} />;
}
